import{isPathToken}from"../tokens/main.js";

import{throwQueryError,throwTokenError}from"./throw.js";







export const normalizeArraysPath=(queryArrays,query)=>{
if(queryArrays.length!==1){
throwQueryError(query,"It must not be a union.")
}

const[path]=queryArrays;
validatePathTokens(path,query);
return path
};


export const validatePath=(path,query)=>{
if(!Array.isArray(path)){
throwQueryError(query,"It must be an array.")
}

if(path.some(Array.isArray)){
throwQueryError(query,"It must not be a union.")
}

validatePathTokens(path,query)
};

const validatePathTokens=(path,query)=>{
path.forEach((prop)=>{
validatePathToken(prop,query)
})
};

const validatePathToken=(prop,query)=>{
if(!isPathToken(prop)){
throwTokenError(
query,
prop,
"It must be a property name or a positive array index."
)
}
};